module.exports = __webpack_public_path__ + "static/media/25-utakksam.b58b795f.mp3";